import { render, staticRenderFns } from "./HeaderSubtitleLoader.vue?vue&type=template&id=2d6b6230&scoped=true&"
import script from "./HeaderSubtitleLoader.vue?vue&type=script&lang=ts&setup=true&"
export * from "./HeaderSubtitleLoader.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./HeaderSubtitleLoader.vue?vue&type=style&index=0&id=2d6b6230&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6b6230",
  null
  
)

export default component.exports